(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['torso/modules/NestedModel'], factory);
  } else if (typeof exports === 'object') {
    // CommonJS-style exports
    module.exports = factory(require('backbone-torso/modules/NestedModel'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (TorsoNestedModel) {
  'use strict';

  /**
   * Model representing a location
   * @class LocationModel
   * @constructor
   * @extends Torso.NestedModel
   */
  return TorsoNestedModel.extend({
    idAttribute: 'code',

    /**
     * @method hasAddress
     * @return {Boolean} true if any address fields have data in them, false otherwise.
     */
    hasAddress: function() {
      var hasLine1 = this.get('address1');
      var hasCity = this.get('city');
      var hasState = this.get('state');
      var hasZip = this.get('zip');
      return !!(hasLine1 || hasCity || hasState || hasZip);
    }
  });
}));
